export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const CLEAR_REGISTER_SUCCESS = 'CLEAR_REGISTER_SUCCESS';

export const registerSuccess = () => ({
    type: REGISTER_SUCCESS,
});

export const clearRegisterSuccess = () => ({
    type: CLEAR_REGISTER_SUCCESS,
});
